import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { SourceGameSpec } from "./spec";

export function evaluateSourceGame(spec: SourceGameSpec): GameplayEvaluationReceipt {
  const sourceBytes = spec.source.markup.length + spec.source.styles.length + spec.source.script.length;
  const checks = [
    { id: "source-contract", passed: true, evidence: "strict source-game parser accepted the complete self-contained bundle" },
    { id: "mechanic-plan", passed: spec.blueprint.systems.length >= 3, evidence: `${spec.blueprint.systems.length} planned game systems` },
    { id: "play-contract", passed: spec.blueprint.acceptanceCriteria.length >= 5, evidence: `${spec.blueprint.acceptanceCriteria.length} explicit acceptance criteria` },
  ] as const;
  return {
    version: 1,
    seed: spec.seed,
    passed: checks.every((check) => check.passed),
    checks,
    trace: [],
    metrics: {
      sourceBytes,
      systems: spec.blueprint.systems.length,
      entities: spec.blueprint.entities.length,
      controls: spec.blueprint.controls.length,
      acceptanceCriteria: spec.blueprint.acceptanceCriteria.length,
    },
  };
}
